export default __webpack_public_path__ + "static/media/Manual de Emissão do Certificado.8e7c2f0e.pdf";